import AddAdministratorForm from './AddAdministratorForm';

export default AddAdministratorForm;
